// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  assembleQuery,
  fetchUsers,
} from 'helpers/api'

const getUserOptions = ({ value }) => {
  const query = [{
    field: 'userNameLike',
    value,
  }]
  return fetchUsers(assembleQuery(query))
}

export default getUserOptions
